import { range } from 'lodash';
import { union } from 'ramda';

type HourInDay =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24;

export type ReminderOption =
  | "don't send"
  | '1 hour'
  | `${Exclude<HourInDay, 1>} hours`;

const _options: ReminderOption[] = union(
  ["don't send", '1 hour'],
  range(2, 25).map((x) => `${x} hours` as ReminderOption),
);

export const options = () => _options;
